import React, { useEffect, useRef } from "react";
import Web3 from "web3";
import { FCard, FGrid, FGridItem } from "ferrum-design-system";
import { toast } from "react-hot-toast";
import { COMING_SOON } from "../../../../utils/const.utils";
import { MdKeyboardArrowDown } from "react-icons/md";
import { SwapPageTokenNetworkSelector } from "./SwapPageTokenNetworkSelector";
import swapSwitchIcon from "../../../../assets/ms-new-images/icons/directional-ms-swap-icon.png";
import addItemIcon from "../../../../assets/ms-new-images/icons/ms-add-item-icon.svg";
import fiberEngineIcon from "../../../../assets/ms-new-images/icons/ms-fiber-engine-icon.png";
import { MobileQuoteAndFiberProgressBarDialog } from "../../components/dialogs/MobileQuoteAndFiberProgressBarDialog";
import vectorMobile from "../../../../assets/img/vectorMobile.png";
import WindowLockWarningIcon from "../../../../assets/img/window-lock-warningicon.png";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducer";
import LoadingIcon from "../../../../assets/img/loading.svg";
import Loader from "../../../../assets/img/loader-m.png";
import toggleIcon from "../../../../assets/ms-new-images/icons/ms-toggle-icon.png";
import { addClassToBodyTag } from "../../../../utils/helperFunctions";
import "react-step-progress-bar/styles.css";
import { useHistory } from "react-router";

const SwapMobilePage = ({
  isApproving,
  setShowTokenSelectorDialog,
  setTokenSelectorDialogFor,
  showTokenSelectorDialog,
  amount,
  setAmount,
  showAmountWarning,
  onSourceAmountChange,
  sourceMaxButton,
  sendToToggle,
  destinationAddress,
  isDestinationAddressValid,
  networkParamsShift,
  setNetworkParamsShift,
  setSendToToggle,
  // setDestinationAddress,
  setIsDestinationAddressValid,
  setCategorizedAndQuoteApiHit,
  inputRef,
  show,
  setShow,
  progressBar,
  destinationMobileProgressBar,
  maxBalance,
  swapActionButton,
  fromInfo,
  toInfo,
  switchFromAndToInfo,
  showSwapToggleDialog,
  setShowSwapToggleDialog,
}: any) => {
  const history = useHistory();
  const sendToMobileRef = useRef<HTMLInputElement>(null);
  const inputMobileRef = useRef<HTMLInputElement>(null);
  const queryParams = new URLSearchParams(window.location.search);
  const {
    estimatedSwapTime,
    sourceTokenCategorizedInfo,
    swapProgressBarStatus,
    isTokenQuoteLoading,
    isSwappingScreenBlocked,
    destinationTokenCategorizedInfo,
  } = useSelector((state: RootState) => state.swap);

  useEffect(() => {
    const inputAmount = queryParams.get("amount");
    const focusType = localStorage.getItem("persist:focusType");
    if (inputAmount) {
      const item = localStorage.getItem("persist:max");
      setAmount(inputAmount);
      setCategorizedAndQuoteApiHit(inputAmount);
      if (item !== "true" && focusType === "amount") {
        inputMobileRef.current?.focus();
      } else if (item === "true" && focusType === "sendToMobile") {
        localStorage.setItem("persist:max", "false");
        inputMobileRef?.current?.setSelectionRange(0, 0);
        inputMobileRef?.current?.focus();
      }
    }
    if (destinationAddress) {
      if (focusType === "sendToMobile") {
        sendToMobileRef.current?.focus();
      }
      setSendToToggle(true);
      setIsDestinationAddressValid(
        toInfo?.network?.isNonEVM
          ? destinationAddress.includes("cudos") &&
              destinationAddress.length === 44
          : Web3.utils.isAddress(destinationAddress)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mobile-view" style={{ lineHeight: "1" }}>
      <>
        {isSwappingScreenBlocked && (
          <div id="overlay">
            <div className="window-lock">
              <img
                className=""
                src={WindowLockWarningIcon}
                alt="window blocked icon"
              />
              <p className="window-lock-text">Swap in progress...</p>
            </div>
          </div>
        )}
        {/* <-----------------------------------HEADER-----------------------------------> */}
        <FGrid className="ms-card-swap-header">
          <FGridItem className="ms-card-heading-info f-p--5 card-heading-m">
            <div>MultiSwap</div>
            <div
              className="ms-card-heading-info-dropdown cursor-pointer "
              onClick={() => {
                // addClassToBodyTag(true);
                // setShowFeeTokenSelectorDialog(true);
                // toast.success(COMING_SOON);
              }}
            >
              <span className="ms-card-mt-10 ms-swap-header-token-name">
                Fee Token:
              </span>
              <span className="ms-card-mt-10">Coming Soon</span>
              <MdKeyboardArrowDown className="ms-card-mt-10" />
            </div>
          </FGridItem>
        </FGrid>

        <FCard variant="multiswap-secondary ms-swap-mobile">
          <FGrid className="swap-data-m">
            <FGridItem className="d-flex jc-end send-to-wrapper">
              <div className="send-to-toggle ms-card-heading-info-address-wrapper">
                <div
                  className={`ms-card-heading-info-address-wrapper ${
                    sendToToggle && "expanded"
                  }`}
                >
                  <div
                    className={`ms-card-heading-info-address ${
                      destinationAddress && isDestinationAddressValid
                        ? "valid-address"
                        : destinationAddress && !isDestinationAddressValid
                        ? "invalid-address"
                        : ""
                    }`}
                  >
                    <div>
                      <span
                        className="d-flex ai ai-center"
                        onClick={() => setSendToToggle(!sendToToggle)}
                      >
                        <img
                          width={"15px"}
                          src={addItemIcon}
                          alt="add item icon"
                          className="cursor-pointer destination-plus-icon"
                        />
                        <span className="cursor-pointer">Send To</span>
                      </span>
                    </div>
                    {sendToToggle && (
                      <input
                        // className="Destination-m"
                        className="f-pl-1"
                        placeholder="Destination Address"
                        value={destinationAddress}
                        ref={sendToMobileRef}
                        onChange={(e: any) => {
                          localStorage.setItem(
                            "persist:focusType",
                            "sendToMobile"
                          );
                          queryParams.set("sendTo", e.target.value);
                          history.push({
                            pathname: "/swap",
                            search: queryParams.toString(),
                          });
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div
                className="ms-card-heading-info-icon cursor-pointer f-mt--2"
                onClick={() => {
                  addClassToBodyTag(true);
                  setShowSwapToggleDialog(true);
                }}
              >
                <img src={toggleIcon} alt="toggle icon" />
              </div>
            </FGridItem>
            <FGrid>
              <FGridItem size={[6, 6]} className="from-section-m">
                <SwapPageTokenNetworkSelector
                  selectorFor={"From"}
                  selectorInfo={fromInfo}
                  isApproving={isApproving}
                  showTokenSelectorDialog={showTokenSelectorDialog}
                  networkParamsShift={networkParamsShift}
                  setNetworkParamsShift={setNetworkParamsShift}
                  setShowTokenSelectorDialog={setShowTokenSelectorDialog}
                  setTokenSelectorDialogFor={setTokenSelectorDialogFor}
                />

                <FGridItem
                  className={`ms-card-select-swap ms-card-select-swap-amount text-end ${
                    showAmountWarning ? "enter-amount" : ""
                  } `}
                >
                  <div className="ms-card-select-swap-amount">
                    <p>
                      <input
                        // onClick={(e: any) => e.target.select()}
                        value={amount ? amount : ""}
                        placeholder="0.0"
                        ref={inputMobileRef}
                        disabled={!fromInfo?.token}
                        inputMode="decimal"
                        // type="number"
                        onChange={(e: any) => {
                          onSourceAmountChange(e);
                        }}
                      />
                    </p>
                    <span className="mobile-max">
                      <span
                        className="ms-card-select-swap-max max-m-color"
                        onClick={(e: any) => {
                          sourceMaxButton();
                        }}
                      >
                        {" "}
                        MAX
                      </span>{" "}
                      {fromInfo?.token?.name
                        ? Number(maxBalance).toFixed(2)
                        : ""}{" "}
                      {fromInfo?.token?.symbol ? fromInfo?.token?.symbol : ""}
                    </span>
                  </div>
                </FGridItem>
              </FGridItem>
            </FGrid>
            <div
              className="f-grid-item f-grid-item-lg-12 f-grid-item-md-12 f-grid-item-sm-12 swap-logo"
              onClick={() => switchFromAndToInfo()}
            >
              <img src={swapSwitchIcon} width="25px" alt="swap icon" />
            </div>
            <FGrid>
              <FGridItem className="to-section-m">
                <SwapPageTokenNetworkSelector
                  selectorFor={"To"}
                  selectorInfo={toInfo}
                  isApproving={isApproving}
                  showTokenSelectorDialog={showTokenSelectorDialog}
                  networkParamsShift={networkParamsShift}
                  setNetworkParamsShift={setNetworkParamsShift}
                  setTokenSelectorDialogFor={setTokenSelectorDialogFor}
                  setShowTokenSelectorDialog={setShowTokenSelectorDialog}
                />
                <FGridItem
                  className={`ms-card-select-swap text-end ${
                    showAmountWarning ? "enter-amount" : ""
                  } `}
                >
                  <div className="ms-card-select-swap-amount">
                    <p>
                      <input
                        className="text-align-left"
                        value={
                          destinationTokenCategorizedInfo?.destinationAmount &&
                          Number(amount) > 0
                            ? destinationTokenCategorizedInfo?.destinationAmount
                            : ""
                        }
                      />
                    </p>
                    {isTokenQuoteLoading ? (
                      <span className="mobile-max">
                        <span className="ms-card-select-swap-max max-m-color">
                          <img
                            className="destination-amount-loader"
                            src={Loader}
                            alt={"loader icon"}
                            height={15}
                            width={15}
                          />
                        </span>
                      </span>
                    ) : null}
                  </div>
                </FGridItem>
              </FGridItem>
              {amount > 0 && fromInfo?.network && toInfo?.network && (
                <MobileQuoteAndFiberProgressBarDialog
                  show={show}
                  setShow={setShow}
                  progressBar={progressBar}
                  destinationMobileProgressBar={destinationMobileProgressBar}
                  swapProgressBar={swapProgressBarStatus}
                />
              )}
            </FGrid>
            <FGridItem size={[6, 6]} className={"d-flex jc-center"}>
              <div className="ms-swap-btn">
                <div className="ms-card-swap-estimated-time estimated-time">
                  {fromInfo?.token && toInfo?.token ? (
                    <img
                      className="loader-m"
                      src={LoadingIcon}
                      alt="loading icon"
                    />
                  ) : (
                    ""
                  )}
                  <span>
                    {!isSwappingScreenBlocked
                      ? "Est. time ~80 sec."
                      : fromInfo?.token && toInfo?.token
                      ? estimatedSwapTime
                      : ""}
                  </span>
                </div>
                <div
                  className={`ms-card-token-button ${
                    !fromInfo?.token || !toInfo?.token ? "" : ""
                  } `}
                >
                  {swapActionButton()}
                </div>
              </div>
            </FGridItem>
          </FGrid>
        </FCard>
        {/* </div> */}
        {fromInfo?.token && toInfo?.token ? (
          <div className="fiber-engine-and-fee-card">
            {amount > 0 &&
            !isTokenQuoteLoading &&
            sourceTokenCategorizedInfo?.type &&
            destinationTokenCategorizedInfo?.type ? (
              <FGrid className="mobile-foundry-view">
                <FGridItem className="mobileFiberEngine">
                  <img src={fiberEngineIcon} alt="fiber Engine Icon" />
                </FGridItem>
                <div className="fiberEngineMobile">
                  <div
                    style={{
                      color: destinationMobileProgressBar ? "white" : "",
                    }}
                  >
                    <div className="d-flex jc jc-between">
                      <p className="fiber-network-type">
                        {sourceTokenCategorizedInfo?.type} Assets
                      </p>
                      <img
                        className="progressbar-fiber-img"
                        src={fromInfo?.network.logo}
                        alt="progressbar logo"
                        width={14}
                        height={14}
                      />
                    </div>
                    <p className="fiberMobileNetwork">Source Network</p>
                  </div>
                  <div>
                    <img src={vectorMobile} alt="vector icon" />
                  </div>

                  <div
                    style={{
                      color: destinationMobileProgressBar ? "white" : "",
                    }}
                  >
                    <div className="d-flex jc jc-between">
                      <p className="fiber-network-type">
                        {destinationTokenCategorizedInfo?.type} Assets
                      </p>
                      <img
                        className="progressbar-fiber-img"
                        src={toInfo?.network.logo}
                        alt="progressbar logo"
                        width={14}
                        height={14}
                      />
                    </div>
                    <p className="fiberMobileNetwork">Destination Network</p>
                  </div>
                </div>
              </FGrid>
            ) : null}
            <div className="mobile-view">
              <div className="feedcard-m">
                <FGrid className="swap-lowercard-value">
                  <FGridItem
                    size={[4, 4, 12]}
                    className="jc jc-center f-mb--3 f-mt--3"
                  >
                    <span
                      className="entity entity-color"
                      onClick={() => {
                        toast.success(COMING_SOON);
                      }}
                    >
                      Platform Fee:
                      <label className="value-color"> TBD</label>
                    </span>
                  </FGridItem>
                  <FGridItem
                    size={[4, 4, 12]}
                    className="jc jc-center f-mb--3 f-mt--3"
                  >
                    <div
                      className="entity entity-color"
                      onClick={() => {
                        toast.success(COMING_SOON);
                      }}
                    >
                      Gas Fee:
                      <span className="value-color"> TBD</span>
                    </div>
                  </FGridItem>
                  <FGridItem
                    size={[4, 4, 12]}
                    className="jc jc-center f-mb--3 f-mt--3"
                  >
                    <span className="entity entity-color">
                      Minimum Recieved:
                      <span className="value-color">
                        {" " +
                          Number(
                            destinationTokenCategorizedInfo?.destinationAmount
                          ).toFixed(5)}
                      </span>
                    </span>
                  </FGridItem>
                  <FGridItem
                    size={[4, 4, 12]}
                    className="jc jc-center f-mb--3 f-mt--3"
                  >
                    <span
                      className="entity entity-color"
                      onClick={() => {
                        toast.success(COMING_SOON);
                      }}
                    >
                      Price Impact:{" "}
                      <span
                        className="value-color"
                        onClick={() => {
                          toast.success(COMING_SOON);
                        }}
                      >
                        {" "}
                        TBD
                      </span>
                    </span>
                  </FGridItem>
                </FGrid>
              </div>
            </div>
          </div>
        ) : null}
      </>
    </div>
  );
};

export default SwapMobilePage;
